/**
 * Rab-bit marka işareti.
 *
 * Logonun SVG olarak yeniden çizimi: hız çizgileri, geriye yatık uzun kulaklar ve
 * mor gradyan. Vektör olduğu için her boyutta ve her temada net; raster bir dosya
 * gömmeye göre de paket boyutunu şişirmiyor.
 *
 * `gradientId` zorunlu: aynı sayfada birden fazla logo varsa (kenar çubuğu + giriş
 * ekranı) aynı id iki kez tanımlanır ve tarayıcı ilkini kullanır — ikinci logo yanlış
 * renklenir. Her kullanım kendi id'sini verir.
 */
export function LogoMark({ id, className = 'brand-mark' }: { id: string; className?: string }) {
  const body = `${id}-body`;
  const ear = `${id}-ear`;
  const speed = `${id}-speed`;

  return (
    <svg className={className} viewBox="0 0 128 128" role="img" aria-label="Rab-bit">
      <defs>
        <linearGradient id={body} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor="var(--brand)" />
          <stop offset="100%" stopColor="var(--brand-bright)" />
        </linearGradient>
        <linearGradient id={ear} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor="var(--brand-bright)" />
          <stop offset="100%" stopColor="var(--brand-light)" />
        </linearGradient>
        <linearGradient id={speed} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="var(--brand-bright)" stopOpacity="0.25" />
          <stop offset="100%" stopColor="var(--brand)" />
        </linearGradient>
      </defs>

      {/* hız çizgileri — gövdenin soluna taşar, hareket hissini onlar veriyor */}
      <g fill={`url(#${speed})`}>
        <rect x="2" y="74" width="11" height="11" rx="5.5" />
        <rect x="18" y="74" width="40" height="11" rx="5.5" />
        <rect x="20" y="52" width="38" height="11" rx="5.5" />
      </g>

      {/* arkadaki koyu kulak */}
      <path d="M86 57C79 41 70 21 74 12c4-9 13-4 16 8 4 14 5 28 5 38Z" fill="var(--brand-deep)" />

      {/* öndeki uzun kulak */}
      <path d="M78 60C63 49 41 35 30 25c-6-6-2-13 7-9 18 8 39 26 49 41Z" fill={`url(#${ear})`} />

      {/* gövde */}
      <path
        d="M84 50c17 0 30 13 30 30 0 10-5 18-13 23-7 4-15 6-24 6H34a7 7 0 0 1 0-14h13c-9-4-14-11-14-19 0-12 11-21 24-21 8 0 15 3 20 8-2-8 3-13 7-13Z"
        fill={`url(#${body})`}
      />

      {/* arka but — gövdeye derinlik veren koyu dalga */}
      <path
        d="M36 95c10-9 24-13 38-11 10 1 18 5 24 11-6 6-15 9-25 9H41c-3 0-5-4-5-9Z"
        fill="var(--brand-deep)"
        opacity="0.22"
      />

      {/* göz */}
      <circle cx="94" cy="72" r="5" fill="#fff" />
    </svg>
  );
}

/** İşaret + kelime markası. Kenar çubuğunda ve giriş ekranında kullanılır. */
export function Logo({ id, subtitle }: { id: string; subtitle?: string }) {
  return (
    <div className="brand">
      <LogoMark id={id} />
      <span>
        <span className="wordmark">
          Rab<em>-bit</em>
        </span>
        {subtitle && (
          <>
            <br />
            <span className="brand-ws">{subtitle}</span>
          </>
        )}
      </span>
    </div>
  );
}
